export enum ThirdPartyApiTags {
  Prompt = 'Prompt',
  ThirdPartyApiSettings = 'ThirdPartyApiSettings',
  Balance = 'Balance',
}

export const thirdPartyApiTagTypes = Object.values(ThirdPartyApiTags);
